import { HideDropdownMenuType } from '../actions/actionTypes';

const dropdownMenuState = {
    hiddenDropdownList: {}
}

const getDropdownMenuState = () => {
    const dropdownMenu = localStorage.getItem("dropdownMenu");

    try {
        if(dropdownMenu !== null){
            const dropdownMenuObj = JSON.parse(dropdownMenu);    
            return dropdownMenuObj;
        }

        return dropdownMenuState;
    } catch (error) {
        console.log('dropdownMenuReducer getDropdownMenuState error: ' + JSON.stringify(error));
        return dropdownMenuState
    }
}

const newDropdownMenu = getDropdownMenuState();

const chosenDropdownMenuReducer = (state=newDropdownMenu, action) => {

    switch(action.type){
        case HideDropdownMenuType.SHOWDROPDOWNMENU:
            return action.type        
        case HideDropdownMenuType.HIDEDROPDOWNMENU:
            var idx = state.dropdownMenuState['hiddenDropdownList'].indexOf(action.payload);
            return action.type ;
        case HideDropdownMenuType.BATTERY_PROGRAM:       

            if(!('BATTERY_PROGRAM' in state['hiddenDropdownList'])){
                state['hiddenDropdownList']['BATTERY_PROGRAM'] = 'HIDE'
            }
            else if(state['hiddenDropdownList']['BATTERY_PROGRAM'] === 'HIDE'){
                state['hiddenDropdownList']['BATTERY_PROGRAM'] = 'SHOW'   
            }
            else{
                state['hiddenDropdownList']['BATTERY_PROGRAM'] = 'HIDE'
            }

            localStorage.setItem("dropdownMenu", JSON.stringify(state));

            return {...state };  
        case HideDropdownMenuType.OPERATIONS:
            //var idx2 = state.dropdownMenuState['hiddenDropdownList'].indexOf(action.payload);
            return action.type ;              
            
        default:
            return state;
    }

}

export default chosenDropdownMenuReducer;